// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 25%);
  width: 25%;
  text-align: center;
  align-items: center;
  max-width: 500px;
  padding: 20px;
  text-align: center;
}

@media only screen and (max-width: 955px) {
  .login-container {
    width: 40%;
  }
}

@media only screen and (max-width: 768px) {
  .login-container {
    width: 50%;
  }
}

@media only screen and (max-width: 550px) {
  .login-container {
    width: 60%;
  }
}

@media only screen and (max-width: 400px) {
  .login-container {
    width: 80%;
  }
}

@media only screen and (max-width: 400px) {
  .login-container {
    width: 100%;
  }
}

.login-container>img {
  width: 95px;
  margin: auto;
}

.login-container h1 {
  font-size: 1.5rem;
  margin-bottom: 20px;
  font-family: 'Arial', sans-serif;
}

.login-container label {
  display: block;
  text-align: left;
  margin-bottom: 10px;
}

.login-container div {
  display: flex;
  justify-items: center;
  align-items: center;
  border: 1px solid rgb(21, 95, 93);
  margin-bottom: 20px;
  border-radius: 4px;
  width: 100%;
  background-color: rgb(21, 95, 93);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}

.login-container input[type="text"],
.login-container input[type="password"] {
  width: 85%;
  font-size: 16px;
  padding: 10px;
  border: none;
  outline: none;
  background-color: none;

}

.login-container input[type="submit"] {
  background-color: #4CAF50;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
}

.login-container input[type="submit"]:hover {
  background-color: #3e8e41;
}

.outer-container {
  display: flex;
  flex-direction: column;
  /* justify-content: center;
  align-items: center; */
  padding: 10px;
}


.inner-container {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

/* CSS for the icons */
.toolicon {
  margin-right: 10px;
}

/* CSS for the text */
.tooltext {
  font-size: 16px;
}

/* CSS for the icon and text container */
.info-container {
  display: flex;
  align-items: center;
}

/* CSS for the icons */
.info-container .toolicon {
  margin-right: 10px;
}

/* CSS for the label */
.info-container .toollabel {
  font-weight: bold;
  margin-right: 5px;
}

/* CSS for the value */
.info-container .toolvalue {
  font-size: 14px;
  color: #888;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/login/login.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,+BAA+B;EAC/B,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;;EAEE,UAAU;EACV,eAAe;EACf,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;;AAExB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB;wBACsB;EACtB,aAAa;AACf;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,WAAW;AACb","sourcesContent":[".login-container {\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, 25%);\n  width: 25%;\n  text-align: center;\n  align-items: center;\n  max-width: 500px;\n  padding: 20px;\n  text-align: center;\n}\n\n@media only screen and (max-width: 955px) {\n  .login-container {\n    width: 40%;\n  }\n}\n\n@media only screen and (max-width: 768px) {\n  .login-container {\n    width: 50%;\n  }\n}\n\n@media only screen and (max-width: 550px) {\n  .login-container {\n    width: 60%;\n  }\n}\n\n@media only screen and (max-width: 400px) {\n  .login-container {\n    width: 80%;\n  }\n}\n\n@media only screen and (max-width: 400px) {\n  .login-container {\n    width: 100%;\n  }\n}\n\n.login-container>img {\n  width: 95px;\n  margin: auto;\n}\n\n.login-container h1 {\n  font-size: 1.5rem;\n  margin-bottom: 20px;\n  font-family: 'Arial', sans-serif;\n}\n\n.login-container label {\n  display: block;\n  text-align: left;\n  margin-bottom: 10px;\n}\n\n.login-container div {\n  display: flex;\n  justify-items: center;\n  align-items: center;\n  border: 1px solid rgb(21, 95, 93);\n  margin-bottom: 20px;\n  border-radius: 4px;\n  width: 100%;\n  background-color: rgb(21, 95, 93);\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);\n}\n\n.login-container input[type=\"text\"],\n.login-container input[type=\"password\"] {\n  width: 85%;\n  font-size: 16px;\n  padding: 10px;\n  border: none;\n  outline: none;\n  background-color: none;\n\n}\n\n.login-container input[type=\"submit\"] {\n  background-color: #4CAF50;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 1rem;\n}\n\n.login-container input[type=\"submit\"]:hover {\n  background-color: #3e8e41;\n}\n\n.outer-container {\n  display: flex;\n  flex-direction: column;\n  /* justify-content: center;\n  align-items: center; */\n  padding: 10px;\n}\n\n\n.inner-container {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n/* CSS for the icons */\n.toolicon {\n  margin-right: 10px;\n}\n\n/* CSS for the text */\n.tooltext {\n  font-size: 16px;\n}\n\n/* CSS for the icon and text container */\n.info-container {\n  display: flex;\n  align-items: center;\n}\n\n/* CSS for the icons */\n.info-container .toolicon {\n  margin-right: 10px;\n}\n\n/* CSS for the label */\n.info-container .toollabel {\n  font-weight: bold;\n  margin-right: 5px;\n}\n\n/* CSS for the value */\n.info-container .toolvalue {\n  font-size: 14px;\n  color: #888;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
